type Props = {
    color?: string;
    width?: number;
    height?: number;
};

export default function IconArrowForward({
    color = 'black',
    width = 22,
    height = 22,
}: Props) {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox="0 0 24 24" fill="none">
            <path d="M15.275 12L7.925 19.35C7.675 19.6 7.5542 19.8958 7.5625 20.2375C7.5708 20.5792 7.7 20.875 7.95 21.125C8.2 21.375 8.4958 21.5 8.8375 21.5C9.1792 21.5 9.475 21.375 9.725 21.125L17.4 13.425C17.6 13.225 17.75 13 17.85 12.75C17.95 12.5 18 12.25 18 12C18 11.75 17.95 11.5 17.85 11.25C17.75 11 17.6 10.775 17.4 10.575L9.7 2.875C9.45 2.625 9.1583 2.5042 8.825 2.5125C8.4917 2.5208 8.2 2.65 7.95 2.9C7.7 3.15 7.575 3.4458 7.575 3.7875C7.575 4.1292 7.7 4.425 7.95 4.675L15.275 12Z" fill={color} />
        </svg>
    );
}
